/**
 * Team roster.
 *
 * Ported from `public/index.html:640-651`. Order, names, and profile links are
 * unchanged; the images are bundled rather than read from `/public/static`.
 */
import Michal from './assets/Michal.png';
import aman from './assets/aman.png';
import bruce from './assets/bruce.png';
import nathan from './assets/nathan.png';
import pankaj from './assets/pankaj.png';
import peixin from './assets/peixin.png';
import shunya from './assets/shunya.png';
import surya from './assets/surya.png';

export interface TeamMember {
  name: string;
  role: string;
  image: string;
  link: string;
}

export const TEAM_MEMBERS: TeamMember[] = [
  {
    name: 'Pankaj Rajdeo*',
    role: '',
    image: pankaj,
    link: 'https://www.linkedin.com/in/pankajrajdeo'
  },
  {
    name: 'Shunya Asanuma',
    role: '',
    image: shunya,
    link: 'https://www.linkedin.com/in/shunya-asanuma-3436161ba/'
  },
  {
    name: 'Michal Kouril',
    role: '',
    image: Michal,
    link: 'https://www.cincinnatichildrens.org/bio/k/michal-kouril'
  },
  {
    name: 'Peixin Lu',
    role: '',
    image: peixin,
    link: 'https://www.linkedin.com/in/peixin-lu-04a860262/'
  },
  { name: 'Aman Chadha', role: '', image: aman, link: 'https://aman.ai' },
  {
    name: 'Surya Prasath',
    role: '',
    image: surya,
    link: 'https://www.prasathlab.com/about/members/pi'
  },
  {
    name: 'Bruce J. Aronow',
    role: '',
    image: bruce,
    link: 'https://www.cincinnatichildrens.org/bio/a/bruce-aronow'
  },
  {
    name: 'Nathan Salomonis',
    role: '',
    image: nathan,
    link: 'https://www.cincinnatichildrens.org/bio/s/nathan-salomonis'
  }
];
